import { useBarContext } from "@/components/BannerSlider/components/controls/components/progressBar/components/bar/context/bar.context";

import { Base } from "./bar.base";
import { Content } from "./components/content";

export const Bar = Object.assign(Base, {
    useContext: useBarContext,
    Content: Content
});
